export default __webpack_public_path__ + "static/media/js.de61327c.svg";